<template>
  <div v-if="!isLogined" style="padding-top:300px;">
      <p>您还没有登录哦，请先登录</p>
      <van-button round @click="ShowLogin" type="info">点击登录</van-button>
  </div>
  <div v-else>
     <van-nav-bar title="我的订单" left-text="" left-arrow @click-left="onClickLeft()" />
     <van-tabs v-model="active" @change="changeStatus()">
      <van-tab title="全部"></van-tab>
      <van-tab title="待确认"></van-tab>
      <van-tab title="待发货"></van-tab>
      <van-tab title="待收货"></van-tab>
      <van-tab title="已完成"></van-tab>
     </van-tabs>
     <div class="container">
       
      <van-panel
        v-for="order in orderlist"
        :key="order.ID"
        :title="order.OrderCode"
        :status="orderStatus(order.Status)"
      >
        <div>
          <van-card
            v-for="item in order.OrderDetail"
            :key="item.ID"
            :num="item.Num"
            :price="item.UnitPrice"
            desc
            thumb="https://cdn.jsdelivr.net/npm/@vant/assets/ipad.jpeg"
            :title="item.GoodsName"
          >
            <div class="goods-price">
              {{item.UnitPrice}}
            </div>
            <template #tags v-if="item.Specs!=null">
              <van-tag plain type="danger" style="margin-left:15px;">{{item.Specs}}</van-tag>
            </template>
          </van-card>
        </div>
        <div slot="footer" class="footer-action" style="text-align:right;">
          <template v-if="order.Status==0">
            <van-tag type="danger" size="medium" @click="cancelOrder(order)">取消订单</van-tag>
            <!-- <van-button size="small" @click="cancelOrder(order)">取消订单</van-button> -->
          </template>
          <template v-if="order.Status==2">
            <van-tag type="danger" size="medium" @click="confirmOrder(order)">确认收货</van-tag>
            <!-- <van-button size="small" type="info" @click="confirmOrder(order)">确认收货</van-button> -->
          </template>
        </div>
      </van-panel>
      
     
     </div>
  </div>
</template>

<script>
import { Row, Col, Icon, Cell, CellGroup, Tabs, Tab, NavBar, Card, Panel, Tag } from "vant";
import { Button, Field } from "vant";
import { Divider } from "vant";
import { Popup } from "vant";
import { CountDown } from 'vant';
import { Dialog } from 'vant';
export default {
  name: "OrderListnew",
  data() {
    return {      
      avatar: this.$file.url + "Images/Mall/UserDefaultAvatar/" + "user.jpg",
      orderlist: [],
      status: null,
      active: 0,
    };
  },
  props: {},
  computed:{
    isLogined(){return this.$store.state.isLogin}
  },
  methods: {
    ShowLogin(){
      this.$store.commit("showLogin");
    },
    GetOrderData(status){
      var that=this;
      if(this.isLogined){
        this.$http.get("Order/GetOrdersList?status=" + status).then(res=>{        
          that.orderlist=res.data.Data;
        });
      }
    },
    /*获取所有订单 */
    GetAllOrderData(){
      var that=this;
      if(this.isLogined){
        this.$http.get("Order/GetOrderList").then(res=>{        
          that.orderlist=res.data.Data;
        });
      }
    },
    /*订单状态获取订单列表 */
    onclickStatus(){
        var status = this.active > 0 ? this.active - 1 : undefined;
        if(status!=undefined){
            this.status = status;
            this.GetOrderData(status);
        }else{
            this.status = undefined;
            this.GetAllOrderData();
        }
    },
    /*订单状态改变 */
    changeStatus() {
      this.orderlist = [];
      this.onclickStatus();
    },
    /*返回 */
    onClickLeft() {
      this.$router.back(-1);
    },
    /*订单状态 */
    orderStatus(status) {
      switch (status) {
        case 0:
          return "待确认";
        case 1:
          return "待发货";
        case 2:
          return "待收货";
        case 3:
          return "已完成";
        case -1:
          return "已取消";
      }
    },
    /*取消订单 */
    cancelOrder: function(item) { 
      var that = this;
      Dialog.confirm({
        title: '提示',
        message: '确认要取消订单吗?',
        })
        .then(() => {
           that.$http
            .get("Order/CancelOrder", {
              params: {
                id: item.ID
              }
            })
            .then(res => {
              if (res.data == "success") {
                that.$toast("操作成功");
                that.onclickStatus(that.status);
              } else {
                that.$toast(res.data);
              }
            });
        })
        .catch(() => {
           
        });
    },
    /*确认收货 */
    confirmOrder: function(row) {
      var that = this;
      this.$http("Order/UpdateOrderStatus", {
        params: { 
            id: row.ID, 
            Status: 3 
        }
      }).then(res => {
        that.$toast("操作成功");
        that.onclickStatus(that.status);
      });
    },
  },
  created() {
    this.status = this.$route.params.status;
    if(this.status==undefined){
        this.active = 0;
        this.GetAllOrderData();
    }else{
        this.active = this.status * 1 + 1;
        this.GetOrderData(this.status);
    }
    
  },
  components: {
    [Row.name]: Row,
    [Col.name]: Col,
    [Icon.name]: Icon,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Divider.name]: Divider,
    [Button.name]: Button,
    [Popup.name]: Popup,
    [Field.name]: Field,
    [CountDown.name]:CountDown,
    [Tabs.name]: Tabs,
    [Tab.name]: Tab,
    [NavBar.name]: NavBar,
    [Card.name]: Card,
    [Panel.name]: Panel,
    [Dialog.name]: Dialog,
    [Tag.name]: Tag,
  },
};
</script>

<style scoped>
    .van-panel {
    margin-top: 20px;
  }
</style>
